import { z } from 'zod';

// Parsed at runtime, unlike the event schemas in ./index, so these live apart: a value
// import from ./index would pull every event schema into the embed widget's eager bundle.

/** The server's `giftCardUsageError` codes the plan lists; any other failure is `unknown`. */
export const paymentMethodFailedErrorTypeSchema = z.enum([
  'expired',
  'expired_at_time_of_service',
  'no_credit',
  'associated_to_other_calendar',
  'calendar_does_not_accept_gift_cards',
  'already_paid',
  'not_valid',
  'already_used_on_booking',
  'service_price_not_valid_for_ugc_type',
  'service_vat_not_valid_for_ugc_type',
  'not_valid_service_category',
  'service_is_not_enabled_as_wellness_by_merchant',
  'failed_to_validate_giftcard',
  'unknown_service_price',
  'unknown',
]);

/** The server's save codes the plan lists; any other failure is `unknown`. */
export const giftCardSaveFailedErrorTypeSchema = z.enum([
  'expired',
  'not_found',
  'empty',
  'already_saved',
  'already_saved_another_account',
  'not_supported',
  'invalid_type',
  'invalid',
  'link_use_expired',
  'link_already_used',
  'unknown',
]);
